import { render, staticRenderFns } from "./RegistrationDetailsEditCustomer.vue?vue&type=template&id=54c7cd9d"
import script from "./RegistrationDetailsEditCustomer.vue.ts?vue&type=script&lang=ts&external"
export * from "./RegistrationDetailsEditCustomer.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports